<template>
  <div class="appMain">
    <div class="appMainView">
      <router-view></router-view>
    </div>
    <div class="appMainNav">
      <div :class="['appMainNavItem',{'navActive':myIndex==1}]" @click="gotoPage(1)">
         <i class="iconfont">&#xe615;</i>
         <span>首页</span> 
      </div>
      <div :class="['appMainNavItem',{'navActive':myIndex==2}]" @click="gotoPage(2)">
        <i class="iconfont">&#xe7b8;</i>
         <span>品牌</span> 
      </div>
        <!-- <div :class="['appMainNavItem',{'navActive':myIndex==4}]" @click="gotoPage(4)">
            <i class="iconfont">&#xe7f9;</i>
            <span>分类</span>
        </div> -->
      <div :class="['appMainNavItem',{'navActive':myIndex==3}]" @click="gotoPage(3)">
        <i class="iconfont">&#xe646;</i>
         <span>我的</span> 
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'appMain',
  data(){
    return {
      myIndex:1,
    }
  },
  mounted(){
      if(this.$route.query.pageId){
          this.myIndex = this.$route.query.pageId
      }

  },
  methods:{
    gotoPage(idx){
      switch(idx){
        case 1:
          this.$router.push({path:"/appMain/home",query:{pageId:1}})//pageId记录当前页
          break
        case 2:
          this.$router.push({path:"/appMain/brand",query:{pageId:2}})
          break
        case 4:
          this.$router.push({path:"/appMain/classify",query:{pageId:4}})
          break
        case 3:
          this.$router.push({path:"/appMain/member",query:{pageId:3}})
      }
      this.myIndex = idx
    }
  }
}
</script>
<style lang="scss" scoped>
  .appMain{
    width: 100%;
    height: 100%;
    position: relative;
    .appMainView{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 55px;
      overflow-x: hidden;
      overflow-y: auto;
      -webkit-overflow-scrolling : touch;
      background: #fff;
    }
    .appMainNav{
      position: absolute;
      height: 55px;
      left: 0;
      right: 0;
      bottom: 0;
      background: #fff;
      box-shadow: 0 -1px 4px 0 rgba(0,0,0,0.1);
      display: flex;
        z-index: 1000;
      .appMainNavItem{
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #333;
        i{
          font-size: 18px;
        }
      }
      .navActive{
        color: #149dfe;
      }
    }
  }
</style>
